import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  connectionStatus: 'disconnected', // 'connected', 'disconnected', 'connecting', 'error'
  connectionDetails: null,
  reconnectAttempts: 0,
  events: [], // Recent real-time events
  activeUsers: [], // Currently online users
  lastEventTimestamp: null,
};

const realtimeSlice = createSlice({
  name: 'realtime',
  initialState,
  reducers: {
    setConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload.status;
      state.connectionDetails = action.payload.details || null;
      
      if (action.payload.status === 'connected') {
        state.reconnectAttempts = 0;
      }
    },
    setReconnectAttempts: (state, action) => {
      state.reconnectAttempts = action.payload;
    },
    addRealtimeEvent: (state, action) => {
      const event = {
        ...action.payload,
        id: `${action.payload.type}_${Date.now()}_${Math.random()}`,
      };
      
      state.events.unshift(event);
      state.lastEventTimestamp = event.timestamp;
      
      // Keep only the last 100 events
      if (state.events.length > 100) {
        state.events = state.events.slice(0, 100);
      }
    },
    clearRealtimeEvents: (state) => {
      state.events = [];
    },
    setActiveUsers: (state, action) => {
      state.activeUsers = action.payload;
    },
    addActiveUser: (state, action) => {
      const user = action.payload;
      const existingIndex = state.activeUsers.findIndex(u => u.id === user.id);
      
      if (existingIndex === -1) {
        state.activeUsers.push(user);
      } else {
        state.activeUsers[existingIndex] = user;
      }
    },
    removeActiveUser: (state, action) => {
      const userId = action.payload;
      state.activeUsers = state.activeUsers.filter(user => user.id !== userId);
    },
    markEventAsRead: (state, action) => {
      const eventId = action.payload;
      const event = state.events.find(e => e.id === eventId);
      if (event) {
        event.read = true;
      }
    },
  },
});

export const {
  setConnectionStatus,
  setReconnectAttempts,
  addRealtimeEvent,
  clearRealtimeEvents,
  setActiveUsers,
  addActiveUser,
  removeActiveUser,
  markEventAsRead,
} = realtimeSlice.actions;

export default realtimeSlice.reducer;